/* eslint eqeqeq: off */
import React, {Component} from "react";
import Modal, {ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import {connect} from "react-redux";
import Hospital from "../../../Server/Hospital";
import PropTypes from "prop-types";
import Input from "../../../Components/Control/Input";
import Group from "../../../Components/Group";
import Grid, {GridButton, GridControls, gridDateTime, GridState, GridStates} from "../../../Components/Grid";
import './index.css';
import Resource from "../../../Resource";
import ModalPrint from "../ModalPrint";
import {updateBase} from "../../../Redux/Actions/base";
import Notif from "../../../Components/Notif";
import Prompt, {PromptControl} from "../../../Components/Prompt";
import {HospitalWashRequest} from '../../../Server/WashRequest';
import Perms from '../../../Perms';

class ModalHospitalRequestProducts extends Component {
    constructor (props) {
        super(props);
        props.refer.current = this;

        this.Perms = {
            WASH: {
                ADD_PRODUCT: Perms().BLOOD_BANK_WASH_REQUESTS.ADD_PRODUCT,
                REMOVE_PRODUCT: Perms().BLOOD_BANK_WASH_REQUESTS.REMOVE_PRODUCT,
                SENT_TO_ORG: Perms().BLOOD_BANK_WASH_REQUESTS.SENT_TO_ORG
            },
            IRRADIATE: {
                ADD_PRODUCT: Perms().BLOOD_BANK_IRRADIATE_REQUESTS.ADD_PRODUCT,
                REMOVE_PRODUCT: Perms().BLOOD_BANK_IRRADIATE_REQUESTS.REMOVE_PRODUCT,
                SENT_TO_ORG: Perms().BLOOD_BANK_IRRADIATE_REQUESTS.SENT_TO_ORG
            }
        };

        this.state = {
            grid: {
                columnDefs: [{
                    field: 'productNumber',
                    headerName: 'شماره فرآورده',
                    headerTooltip: 'شماره فرآورده',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    filter: 'agTextColumnFilter'
                }, {
                    field: 'productTypeStr',
                    headerName: 'نوع فرآورده',
                    headerTooltip: 'نوع فرآورده'
                }, {
                    field: 'productBloodGroupStr',
                    headerName: 'BGRh فرآورده',
                    headerTooltip: 'BGRh فرآورده',
                    cellClass: row => 'green'
                }, {
                    field: 'productExpireDate',
                    headerName: 'زمان انقضا',
                    headerTooltip: 'زمان انقضا',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime.bind(this, 'date')
                }, {
                    field: 'crossMatcherFullName',
                    headerName: 'انجام دهنده',
                    headerTooltip: 'انجام دهنده'
                }, {
                    field: 'createDateTime',
                    headerName: 'زمان آماده سازی',
                    headerTooltip: 'زمان آماده سازی',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime
                }, {
                    field: 'crossMatchStatusStr',
                    headerName: 'وضعیت',
                    headerTooltip: 'وضعیت',
                    cellRenderer: 'state',
                    pinned: props.gridDefaultSettings.pinStatusColumn,
                    valueGetter: row => row.data.crossMatchStatusStr
                }, {
                    field: 'crossMatchStatusId',
                    sort: 'asc',
                    hide: true,
                    suppressColumnsToolPanel: true,
                    suppressFiltersToolPanel: true
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    // hide: !(this.Perms[this.state.action].ADD_PRODUCT || this.Perms[this.state.action].REMOVE_PRODUCT),
                    minWidth: 155,
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    state: row => {
                        return <GridStates>
                            {row.data.crossMatchStatusId == 30 && <GridState theme={'green'}>{row.data.crossMatchStatusStr}</GridState>}
                            {row.data.crossMatchStatusId == 25 && <GridState theme={'blue'}>{row.data.crossMatchStatusStr}</GridState>}
                            {row.data.crossMatchStatusId == 32 && <GridState theme={'yellow'}>{row.data.crossMatchStatusStr}</GridState>}
                        </GridStates>;
                    },
                    control: row => {
                        return <GridControls>
                            {this.Perms[this.state.action].ADD_PRODUCT && row.data.crossMatchStatusId == 30 && <GridButton type={"button"} theme={'blue'} icon={Resource.IMAGE.PACK.PLUS.WHITE} title={'افزودن'} onClick={this.sendProductToWashIrradiateClickHandler.bind(this, row.data)}/>}
                            {this.Perms[this.state.action].REMOVE_PRODUCT && row.data.crossMatchStatusId == 32 && <GridButton type={"button"} theme={'edit'} icon={Resource.IMAGE.PACK.MINUS.BLACK} title={'حذف'} onClick={this.cancelSentToWashIrradiateClickHandler.bind(this, row.data)}/>}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node) {
                        return [{
                            name: `افزودن فرآورده`,
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.PLUS.BLACK}" alt="">`,
                            action: this.sendProductToWashIrradiateClickHandler.bind(this, params.node.data),
                            disabled: !(params.node.data.crossMatchStatusId == 30 && this.Perms[this.state.action].ADD_PRODUCT)
                        }, {
                            name: 'حذف فرآورده',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.MINUS.BLACK}" alt="">`,
                            action: this.cancelSentToWashIrradiateClickHandler.bind(this, params.node.data),
                            disabled: !(params.node.data.crossMatchStatusId == 32 && this.Perms[this.state.action].REMOVE_PRODUCT)
                        },
                            'separator',
                            ...params.defaultItems];
                    }
                }
            },
            gridContext: null,
            error: false,
            loading: false,
            updated: false,
            data: {},
            selectedRows: []
        };

        this.ref = {
            grid: React.createRef(),
            modal: React.createRef(),
            prompt: React.createRef(),
            send: React.createRef(),
            close: React.createRef(),
        };
    }

    static defaultProps = {
        refer: {current:null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        const {state} = this;

        return state.error !== nextState.error ||
            state.loading !== nextState.loading ||
            state.data !== nextState.data ||
            state.selectedRows !== nextState.selectedRows;
    }

    render () {
        const {state} = this;

        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalHospitalRequestProducts'}
                   size={'large'}
                   error={state.error}
                   loading={state.loading}
                   style={{minHeight: 'calc(100vh - 60px)'}}
                   title={`لیست فرآورده‌های کراسمچ شده بیمار / اضافه شده به درخواست :`}
                   onClose={this.onModalClose.bind(this)}>
                <ModalContent style={{display: 'flex', flexDirection: 'column'}}>
                    <Group className={'mar-b-10'}>
                        <div className="dis-f">
                            <Input className={'pad-4 fb-5 fb-3x-10 fb-2x-20'} label={'شماره پرونده'} value={state.data?.patientFileCode} readOnly={true} align={'center'}/>
                            <Input className={'pad-4 fb-5 fb-3x-10 fb-2x-20'} label={'نام بیمار'} value={state.data?.patientFirstName} readOnly={true}/>
                            <Input className={'pad-4 fb-5 fb-3x-10 fb-2x-20'} label={'نام خانوادگی بیمار'} value={state.data?.patientLastName} readOnly={true}/>
                            <Input className={'pad-4 fb-5 fb-3x-10 fb-2x-20'} label={'گروه خونی'} value={state.data?.patientBloodGroupStr} readOnly={true} align={'center'} direction={'ltr'}/>
                        </div>
                    </Group>
                    <Group className={'ModalHospitalRequestProducts-group'}>
                        <Grid refer={ this.ref.grid } id={'hospitalDeliveryHistoryGrid'} {...this.state.grid} rowData={this.state.data?.crossMatchList || []} onGridReady={this.gridReadyHandler.bind(this)} onSelectionChanged={this.gridSelectHandler.bind(this)}/>
                    </Group>
                </ModalContent>
                <ModalControls>
                    {this.Perms[this.state.action]?.SENT_TO_ORG && <Button refer={this.ref.send} className={'mar-4'} theme={'blue'} onClick={this.sendRequestToOrg.bind(this)}>ارسال درخواست به سازمان</Button>}
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <Prompt ref={this.ref.prompt}/>
            <ModalPrint refer={this.ref.modalPrint}/>
        </React.Fragment>;
    }

    cancelSentToWashIrradiateClickHandler (row, props = {loading: _ => null}) {
        this.ref.prompt.current.open({
            title: 'اخطار',
            description: 'آیا می خواهید فرآورده اضافه شده به درخواست حذف گردد؟',
            size: 'small',
            buttons: PromptControl.YES_NO,
            onClose: button => {
                if (button.id === PromptControl.YES) {
                    props.loading();
                    HospitalWashRequest.removeProduct({
                        sectionRequestId: this.state.data.sectionRequestId,
                        crossMatchId: row?.crossMatchId
                    }).then(_ => {
                        this.getCrossMatchData();

                        this.setState({updated: true});

                        new Notif(Resource.STRING.FETCH.DELETE_SUCCESSFUL).show();
                        props.loading(false);
                    }).catch(message => {
                        new Notif({message, theme: 'error'}).show();
                        props.loading(false);
                    });
                }
            }
        });
    }

    gridReadyHandler (params) {
        this.setState({gridContext: params});
    }

    gridSelectHandler (rows) {
        this.setState({selectedRows: rows});
    }

    modalSuccessHandler () {
        this.getCrossMatchData();

        this.setState({
            selectedRows: [],
            updated: true
        });
    }

    sendProductToWashIrradiateClickHandler (row, props = {loading: _ => null}) {
        props.loading();

        HospitalWashRequest.addProduct({
            sectionRequestId: this.state.data.sectionRequestId,
            crossMatchIdList: [row.crossMatchId]
        }).then(_ => {
            props.loading(false);

            new Notif('فرآورده‌ جهت شستشو به درخواست اضافه شدند.').show();

            this.getCrossMatchData();
        }).catch(message => {
            props.loading(false);

            new Notif({message, theme: 'error'}).show();
        });
    }

    sendRequestToOrg () {
        this.setState({loading: 'در حال ارسال درخواست ...'});

        HospitalWashRequest.sendRequestToOrg({sectionRequestId: this.state.data.sectionRequestId})
            .then(_ => {
                this.setState({loading: false, updated: true});

                this.getCrossMatchData();

                new Notif('درخواست خون شسته به سازمان ارسال شد.').show();
            })
            .catch(message => {
                this.setState({loading: false});

                new Notif({message, theme: 'error'}).show();
            });
    }

    onModalClose () {
        if (this.state.updated)
            this.props.onSuccess();
    }

    close () {
        this.ref.modal.current.close();

        this.props.onClose();
    }

    open (data, action) {
        this.setState({
            data,
            action,
            error: null,
            loading: 'در حال دریافت اطلاعات',
            fields: {},
            incompatibleList: [],
            updated: false,
            selectedRows: []
        }, _ => {
            this.getCrossMatchData();
        });

        this.ref.modal.current.open();
    }

    getCrossMatchData () {
        if (this.ref.grid.current)
            this.ref.grid.current.loading();

        this.setState({selectedRows: []});

        Hospital.crossMatchData({patientFileCodeId: this.state?.data?.patientFileCodeId})
            .then(data => {
                this.ref.grid.current.loading(false);

                const result = {...data};
                result.crossMatchList = result.crossMatchList.filter(item => item.crossMatchStatusId != 31);

                this.setState({
                    loading: null,
                    data: {
                        ...this.state.data,
                        ...result
                    }
                });
            })
            .catch(message => {
                this.ref.grid.current.error();
                new Notif({message, theme: 'error'}).show();
                this.close();
            });
    }
}

const mapStateToProps = state => {
    return {
        base: state.base,
        gridDefaultSettings: state.grid.defaultSettings
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateBase: props => dispatch(updateBase(props))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalHospitalRequestProducts);